import React, { useCallback } from "react";
import styled from "styled-components";
import useLocalStorage from "../Hooks/useLocalStorage";
import { InstructionsPopup, NamePrompt } from "./Common/Popup";
import { usePlayersContext, useSocketContext } from "./Common/Contexts";
import Button from "./Common/Button";
import Game from "../Types/Game";
import Games from "./Games";
import { useTranslationContext } from "../Hooks/useTranslationContext";
import HelpIcon from "../Icons/HelpIcon";

const Title = styled.div`
  color: var(--color-bg-tertiery);
  font-size: 3em;
  text-shadow: -5px -5px var(--color-bg-highlight);
  font-weight: bold;
  text-align: center;
`;
const Different = styled.span`
  color: var(--color-bg-tertiery);
  text-shadow: 5px 5px var(--color-bg-highlight);
  font-weight: bold;
`;
const HelpContainer = styled.div`
  color: var(--color-text-light);
  align-self: start;
`;

interface StartScreenProps {
  games: { [gameId: string]: Game };
}

const StartScreen = ({ games }: StartScreenProps) => {
  const [name, setNameInLocalStorage] = useLocalStorage("name", "Bob");
  const socket = useSocketContext();
  const { t, language } = useTranslationContext();
  const { players } = usePlayersContext();
  const showNamePrompt = players[socket.id]?.name === undefined;
  const [showInstructions, setShowInstructions] = useLocalStorage(
    "showInstructions",
    "true"
  );
  const onSubmitName = (newName: string) => {
    setNameInLocalStorage(newName);
    socket.emit("setName", newName);
  };
  const onToggleInstructions = useCallback(() => {
    if (showInstructions === "true") {
      setShowInstructions("false");
    } else {
      setShowInstructions("true");
    }
  }, [showInstructions, setShowInstructions]);
  return (
    <>
      <HelpContainer>
        <HelpIcon onClick={onToggleInstructions} />
        {showInstructions === "true" && (
          <InstructionsPopup
            onClose={onToggleInstructions}
            onOverlayClick={onToggleInstructions}
          />
        )}
      </HelpContainer>
      <Title>
        {`${t["same.but"]} `}
        <Different>{t.different}</Different>
      </Title>
      {showNamePrompt && (
        <NamePrompt
          onSubmit={onSubmitName}
          lastUsedName={name}
          names={Object.values(players)
            .filter((p) => p.isConnected)
            .map((p) => p.name ?? "")}
        />
      )}
      <Games games={games} />
      <Button onClick={() => socket.emit("joinGame", undefined, language)}>
        {t["start.new.game"]}
      </Button>
    </>
  );
};

export default StartScreen;
